import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
    selector: 'app-task-date',
    templateUrl: './task-date.component.html',
    styleUrl: './task-date.component.scss',
    imports: [RouterOutlet]
})
export class TaskDateComponent {

}
